import dayjs from 'dayjs';

// Эссе пишут в начале месяца за предыдущий. Форма открывалась на текущем
// месяце, и часть людей этого не замечала — писали за незакончившийся месяц
// вместо отчётного. До 15-го числа включительно отчётным считаем прошлый
// месяц: 14 сентября открывается август, 16 сентября — сентябрь.
// Это отсечка по числу месяца, а не сдвиг даты на 15 дней — сравнивается
// именно now.date().
export const REPORTING_PERIOD_CUTOFF_DAY = 15;

export interface EssayPeriod {
  year: number;
  // 1..12 — как хранит бэк, а не 0..11 как dayjs.
  month: number;
}

// `now` параметром, а не dayjs() внутри, чтобы поведение на границе месяца
// можно было проверить тестом, не подменяя системное время.
export const reportingPeriod = (now: dayjs.Dayjs = dayjs()): EssayPeriod => {
  // subtract сам откатывает год: 10 января отдаёт декабрь прошлого.
  const base = now.date() <= REPORTING_PERIOD_CUTOFF_DAY ? now.subtract(1, 'month') : now;
  return { year: base.year(), month: base.month() + 1 };
};

/** «сентябрь 2026» на языке интерфейса. Общий для списка эссе и главной. */
export const monthLabel = (year: number, month: number, lang: string): string =>
  dayjs()
    .locale(lang || 'ru')
    .year(year)
    .month(month - 1)
    .format('MMMM YYYY');
